import React, { useState, useEffect } from 'react';
import WorkInProgress from '../../../components/common/WorkInProgress';
import PostCard from './PostCard';
import logo from '../../../assets/policy/Eb-logo.svg'
import iconImage from '../../../assets/policy/Eb-logo-icon.svg'
import PostComposer from './PostModal';
import { getAllFeeds } from '../../../services/Trainer/trainer';

const TrainerUpdates = () => {
  const [feeds, setFeeds] = useState()
  const [loading, setLoading] = useState()


  const fetchData = async () => {
    setLoading(true)
    const data = await getAllFeeds();
    if (data) {
      console.log("Staff data >>>", data);
      setFeeds(data.data);
    }
    setLoading(false)

  };

  useEffect(() => {

    fetchData();

  }, []);

  const posts = [
    {
      id: 1,
      type: 'news',
      title: 'Empowering Beauty',
      description: 'Welcome to Empowering Beauty, your all-in-one solution for empowering beauty aesthetic clinics. Designed with precision and passion, our software revolutionizes how clinics manage appointments',
      image: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-4a26ASp97MINPwOONoxAYvM7HayFY5.png',
      userName: 'John Doe',
      userProfileImage: '/placeholder.svg?height=48&width=48',
      engagementCount: 15
    },
    {
      id: 2,
      type: 'policy',
      title: 'New Privacy Policy Update',
      description: 'We have updated our privacy policy to better serve our users and comply with new regulations.',
      userName: 'Admin',
      userProfileImage: null, // Will show initials
      engagementCount: 8
    },
    {
      id: 3,
      type: 'feed',
      title: 'Community Update',
      description: 'Check out the latest updates from our community members and their amazing achievements.',
      image: '/placeholder.svg?height=200&width=400',
      userName: 'Jane Smith',
      userProfileImage: '/placeholder.svg?height=48&width=48',
      engagementCount: 23
    },
    {
      id: 3,
      type: 'feed',
      title: 'Community Update',
      description: 'Check out the latest updates from our community members and their amazing achievements.',
      image: '/placeholder.svg?height=200&width=400',
      userName: 'Jane Smith',
      userProfileImage: '/placeholder.svg?height=48&width=48',
      engagementCount: 23
    },
    {
      id: 3,
      type: 'feed',
      title: 'Community Update',
      description: 'Check out the latest updates from our community members and their amazing achievements.',
      image: '/placeholder.svg?height=200&width=400',
      userName: 'Jane Smith',
      userProfileImage: '/placeholder.svg?height=48&width=48',
      engagementCount: 23
    }
  ];

  return (
    <div className="container py-4">
      {/* <WorkInProgress /> */}
      <div className="row">
        <div className="col-8 col-md-8 col-lg-8 mx-auto"
          style={{
            height: '100%', maxHeight: '876px', overflowY: 'auto', scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <PostComposer fetchData={fetchData} />
          {
            loading ?
              <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </div>
              :
              feeds && feeds?.length > 0 ?
                feeds && feeds?.map(post => (
                  <PostCard key={post.id} post={post} setFeeds={setFeeds} feeds={feeds} />
                ))
                :
                <div
                  className="col-md-12"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '200px', // Adjust as needed
                    gap: '8px',
                    fontSize: '18px',
                    color: '#666'
                  }}
                >
                  <i className="bi bi-info-circle" style={{ fontSize: '20px' }}></i>
                  No records found
                </div>
          }
        </div>
        <div
          className="col-4 col-md-4 col-lg-4 mx-auto position-relative"
        // style={{ textAlign: 'center' }}
        >
          {/* Main Logo */}
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              maxHeight: '876px'
            }}
          >
            {/* Full Size Logo */}
            <img
              src={logo}
              alt="Logo"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '20px'
              }}
            />

            {/* Centered Icon */}
            <img
              src={iconImage}
              alt="Center Icon"
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none',
              }}
            />
          </div>
        </div>


      </div>
    </div>
  );
};

export default TrainerUpdates;